import styled from 'styled-components';

export const LoginContainer = styled.div`
height: 100vh;
min-height: 1000px;
`;

export const LoginWrapper = styled.div`
display: grid;
height: 100%;
grid-template-columns: 1fr 1fr;

@media screen and (max-width: 900px){
    grid-template-columns: 1fr;
}
`;

export const LoginSectionLeft = styled.div`
display: flex;
flex-direction: column;
height: 100%;
justify-content: center;
align-items: center;
`;

export const LoginSectionRight = styled.div`
display: flex;
flex-direction: column;
height: 100%;
justify-content: center;
align-items: center;
background: linear-gradient(to bottom, #619657, #588d4f, #4f8446, #477c3e, #3e7336, #376c2f, #2f6429, #285d22, #1f551a, #154d12, #0a450a, #003d01);
box-shadow: 5px 5px 20px 10px rgba(0,0,0,0.3);

@media screen and (max-width: 900px){
    display: none;
}
`;

export const LoginForm = styled.form`
display: flex;
flex-direction: column;

@media screen and (max-width: 768px){
    margin-top: 100px;
    margin-bottom: 50px;
}

@media screen and (max-width: 480px){
    margin-top: 150px;
    margin-bottom: 100px;
}
`;

export const LoginLabel = styled.label`
color: #000;
`;

export const LoginInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 425px;
padding-left: 5px;
transition: all 0.2s ease-in-out;

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}

@media screen and (max-width: 768px){
    width: 325px;
}

@media screen and (max-width: 480px){
    width: 275px;
}
`;

export const LoginInput2 = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 30px;
width: 200px;
padding-left: 5px;
transition: all 0.2s ease-in-out;

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}

@media screen and (max-width: 768px){
    width: 150px;
}

@media screen and (max-width: 480px){
    width: 125px;
}
`;

export const InputWrapper = styled.div`
display: flex;
flex-direction: row;
`;

export const LoginButton = styled.button`
width: 100%;
height: 50px;
border-radius: 5px;
border: none;
background: rgb(51,104,44);
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
font-weight: bold;
margin-top: 25px;
margin-left: auto;
margin-right: auto;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}

&:disabled {
  color: #fff;
  background: #808080;

  &:hover {
    cursor: not-allowed;
    transform: scale(1);
    background: #808080;
}
}
`;

export const TextWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const LogoImage = styled.img`
width: 100%;
max-width: 600px;
height: auto;
margin-left: auto;
margin-right: auto;
padding-right: 50px;
padding-left: 50px;
`;

export const FormHeader = styled.h1`
font-size: 28px;
color: #33682c;
margin-bottom: 50px;
text-align: center;
`;

export const CheckboxWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
margin-top: 25px;
`;

export const CheckboxTextWrapper = styled.div`
display: flex;
flex-direction: row;
align-items: center;
`;

export const CheckboxText = styled.p`
font-size: 14px;
color: #000;
margin-left: 10px;

@media screen and (max-width: 768px) {
    font-size: 11px;
}

@media screen and (max-width: 480px) {
    font-size: 10px;
}
`;

export const Checkbox = styled.input`
width: 15px;
height: 15px;
accent-color: #33682c;

&:hover{
    cursor: pointer;
}
`;

export const Remembertext = styled.p`
font-size: 14px;
color: #808080;
margin-left: 10px;
`;

export const RememberWrapper = styled.div`
display: flex;
flex-direction: row;
`;

export const Forgottext = styled.a`
font-size: 14px;
font-weight: bold;
color: #33682c;

&:hover {
    cursor: pointer;
}
`;

export const MobileLogo = styled.img`
width: 100%;
max-width: 200px;
height: auto;
position: absolute;
top: 5vh;
display: none;

@media screen and (max-width: 900px){
    display: block;
}
`;

export const SignUpWrapper = styled.div`
display: flex;
flex-direction: row;
margin-top: 50px;
margin-left: auto;
margin-right: auto;
`;

export const SignUptext = styled.p`
font-size: 14px;
color: #808080;
`;

export const SignUpTextLink = styled.a`
font-size: 14px;
font-weight: bold;
color: #33682c;

&:hover {
    cursor: pointer;
}
`;

export const LoginDescWrapper = styled.div`
display: flex;
flex-direction: column;
margin-top: 100px;
text-align: center;
`;

export const LoginHeader = styled.p`
font-size: 24px;
color: #fff;
`;

export const LoginDesc = styled.p`
font-size: 16px;
color: #fff;
margin-top: 10px;
`;

export const FeedbackText = styled.p`
font-size: 14px;
color: #000;
text-align: center;
margin-top: 25px;
`;

export const ErrorText = styled.p`
font-size: 14px;
color: #fff;
text-align: left;
margin-top: 10px;
border-radius: 10px;
padding: 10px;
background-color: #619657;
`;

export const EmptySpace = styled.div`
height: 30px;
`;
